import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const Home = ({ data }) => {
  const [allModelRandom, setAllModelRandom] = useState([]);
  const premiumModel = data.filter((item) => {
    return item.premium;
  });
  const mainModel = data.filter((item) => {
    return !item.premium;
  });

  const [randomNumber, setRandomNumber] = useState();
  const [limitedList, setLimitedList] = useState();

  const [ifOpenClose, setIfOpenClose] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const [query, setQuery] = useState("");

  const navigate = useNavigate();

  const openAndClose = () => {
    if (ifOpenClose) {
      setAllModelRandom(data);
      setIfOpenClose(false);
    } else {
      const dataFilter = data.filter((item) => {
        return item.id > randomNumber && item.id < limitedList;
      });
      setAllModelRandom(dataFilter);
      setIfOpenClose(true);
    }
  };

  useEffect(() => {
    if (ifOpenClose) {
      setAllModelRandom(data);
    } else {
      const dataFilter = data.filter((item) => {
        return item.id > randomNumber && item.id < limitedList;
      });
      setAllModelRandom(dataFilter);
    }
  }, [ifOpenClose]);

  const searchOpenVerify = (e) => {
    if (searchOpen) {
      setSearchOpen(false);
    } else {
      setSearchOpen(true);
      verifySearch();
    }
  };

  useEffect(() => {
    if (data.length > 1) {
      const number = Math.round(Math.random() * data.length);
      setRandomNumber(number);
    }
  }, [data]);

  useEffect(() => {
    setLimitedList(randomNumber + 4);
  }, [randomNumber]);

  useEffect(() => {
    if (data.length > 3) {
      if (data.length > limitedList) {
        const dataFilter = data.filter((item) => {
          return item.id > randomNumber && item.id < limitedList;
        });
        setAllModelRandom(dataFilter);
      } else {
        const number = Math.round(Math.random() * data.length);
        setRandomNumber(number);
      }
    } else {
      setAllModelRandom(data);
    }
  }, [limitedList]);

  useEffect(() => {
    if (query === "") {
      if (data.length > 3) {
        if (data.length > limitedList) {
          const dataFilter = data.filter((item) => {
            return item.id > randomNumber && item.id < limitedList;
          });
          setAllModelRandom(dataFilter);
        } else {
          const number = Math.round(Math.random() * data.length);
          setRandomNumber(number);
        }
      } else {
        setAllModelRandom(data);
      }
    } else {
      const filterData = data.filter((item) => {
        const title = item.title.toLowerCase();
        return title.includes(query.toLowerCase());
      });
      setAllModelRandom(filterData);
    }
  }, [query]);

  const verifySearch = () => {
    setTimeout(() => {
      document.getElementById("search").focus();
    }, 1000);
  };

  const makeWish = async (id, title) => {
    try {
      await navigator.clipboard.writeText(
        `Olá gostaria de comprar as modificações do ${title} ${id}`
      );
      console.log("Content copied to clipboard");
      alert(
        "Foi copiado o nome e o código do template, entre em contato em nossas redes sociais e cole o texto copiado"
      );
      navigate("/redes");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <main>
      <section className="all_section">
        <div className="search_Container">
          {!searchOpen && (
            <>
              <h2>
                Todos os modelos<span>Todos os modelos, prêmios e padrões</span>
              </h2>
              <i
                className="bi bi-search icons_search"
                onClick={() => searchOpenVerify()}
              ></i>
            </>
          )}

          {searchOpen && (
            <div className="open_search">
              <input
                id="search"
                className="search_content"
                type="text"
                placeholder="Pesquisar e Filtrar"
                onChange={(e) => setQuery(e.target.value)}
              />
              <i
                className="bi bi-x-circle icons_search"
                onClick={() => searchOpenVerify()}
              ></i>
            </div>
          )}
        </div>

        <div className="all_content">
          {allModelRandom &&
            allModelRandom.map((item) => (
              <div key={item.id} className="item_container">
                <img src={item.img} alt={item.title} />
                <p className="title_post">{item.title}</p>
                {item.premium && <span className="span_premium">Prêmio</span>}
                {!item.premium && <span className="span_main">Padrão</span>}
                <div className="buttons_container">
                  <button
                    className="btn_chat"
                    onClick={() => makeWish(item.id, item.title)}
                  >
                    Fazer Pedido
                  </button>
                  <button
                    className="btn_chat"
                    onClick={() => window.open(item.link)}
                  >
                    Ver ao vivo
                  </button>
                </div>
              </div>
            ))}
          <div
            className="item_container background_gradient_main"
            onClick={() => openAndClose()}
          >
            <span>{ifOpenClose ? "-" : "+"}</span>
            <p>{ifOpenClose ? "Ver menos" : "Ver mais +"}</p>
          </div>
        </div>
      </section>
      <section className="premium_section all_section">
        <h2>
          Prêmios<span>Todos os modelos prêmios</span>
        </h2>
        <div className="all_content">
          {premiumModel &&
            premiumModel
              .slice(premiumModel.length - 3, premiumModel.length)
              .map((item) => (
                <div
                  key={item.id}
                  className="item_container"
                  onClick={() => window.open(item.link)}
                >
                  <img src={item.img} alt={item.title} />
                  <p className="title_post">{item.title}</p>
                  {item.premium && <span className="span_premium">Prêmio</span>}
                  {!item.premium && <span className="span_main">Padrão</span>}
                  <div className="buttons_container">
                    <button
                      className="btn_chat"
                      onClick={() => makeWish(item.id, item.title)}
                    >
                      Fazer Pedido
                    </button>
                    <button
                      className="btn_chat"
                      onClick={() => window.open(item.link)}
                    >
                      Ver ao vivo
                    </button>
                  </div>
                </div>
              ))}
          <div
            className="item_container background_gradient_main"
            onClick={() => navigate("/premium")}
          >
            <span>+</span>
            <p>Ver mais +</p>
          </div>
        </div>
      </section>
      <section className="standard_section all_section">
        <h2>
          Padrões<span>Todos os modelos padrões</span>
        </h2>
        <div className="all_content">
          {mainModel &&
            mainModel
              .slice(mainModel.length - 3, mainModel.length)
              .map((item) => (
                <div
                  key={item.id}
                  className="item_container"
                  onClick={() => window.open(item.link)}
                >
                  <img src={item.img} alt={item.title} />
                  <p className="title_post">{item.title}</p>
                  {item.premium && <span className="span_premium">Prêmio</span>}
                  {!item.premium && <span className="span_main">Padrão</span>}
                  <div className="buttons_container">
                    <button
                      className="btn_chat"
                      onClick={() => makeWish(item.id, item.title)}
                    >
                      Fazer Pedido
                    </button>
                    <button
                      className="btn_chat"
                      onClick={() => window.open(item.link)}
                    >
                      Ver ao vivo
                    </button>
                  </div>
                </div>
              ))}
          <div
            className="item_container background_gradient_main"
            onClick={() => navigate("/standard")}
          >
            <span>+</span>
            <p>Ver mais +</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
